import getModifierGroupSingleChoiceTemplateService
  from '~/src/components/products/modifier-groups/modifier-group/modifier-group-single-choice/styles/getModifierGroupSingleChoiceTemplateService'
import { useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import useGetComponentStyle from '~/src/hooks/layout/useGetComponentStyle'

const useModifierGroupSingleChoiceTemplateService = () => {
  const muiTheme = useCustomMuiTheme()
  const componentStyle = useGetComponentStyle('modifiers')

  return getModifierGroupSingleChoiceTemplateService(componentStyle, muiTheme)
}

export default useModifierGroupSingleChoiceTemplateService
